import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';

import { useTheme } from './themeContext'; // Import useTheme
import { getDatabase, ref, push } from 'firebase/database'; // Import necessary functions
import { app } from './firebaseConfig'; // Import your Firebase app

const Contact = () => {
    const { theme } = useTheme();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const database = getDatabase(app); // Initialize the database

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await push(ref(database, 'inbetween_support_web'), {
        email,
        message,
      });
      console.log('Data written to database');
      navigate('/');
    } catch (error) {
      console.error('Error writing to database', error);
    }
  };

  return (
    <div style={{ marginTop: "100px", width: "100%" }}>
        <Header theme={theme} />
      <div className='privacy-policy' style={{ textAlign: "left", padding: "20px", maxWidth: "600px", margin: "auto" }}>
        <h1 type="title" style={{ fontSize: "50px", textAlign: "center" }}>Contact Us</h1>
        <h3><b>Support Form</b></h3>
        <br />
        <form onSubmit={handleSubmit}>
          <b>Email:</b>
          <br />
          <input
            type="text"
            style={{ width: '100%' }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <b>What can we help with?</b>
          <textarea
            style={{ width: '100%' }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          
                <button type='submit' style={{color: theme === 'light' ? 'black' : 'white'}}> <h3>Submit</h3></button>
        </form>
      </div>
    </div>
  );
};

export default Contact;